(() => {
  function initializeDropsDraft(scope) {
    scope.querySelectorAll('product-info[data-dilauss-drops-draft]').forEach((product) => {
      if (product.dataset.dropsDraftReady) return;
      const picker = product.querySelector('variant-selects');
      const data = product.querySelector('[data-dilauss-drops-variants]');
      const priceData = product.querySelector('[data-dilauss-drops-prices]');
      if (!picker || !data || !priceData) return;
      let variants, prices;
      try { variants = JSON.parse(data.textContent); prices = JSON.parse(priceData.textContent); }
      catch { return; }
      product.dataset.dropsDraftReady = 'true';
      const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
      const dropdown = picker.querySelector('select');
      const sync = (variant, changeUrl, updateMedia = true) => {
        if (!variant) return;
        radios.forEach((radio) => { radio.checked = radio.value === variant.option1; });
        if (dropdown) dropdown.value = variant.option1;
        const selected = picker.querySelector('[data-selected-variant]');
        if (selected) selected.textContent = JSON.stringify(variant);
        product.querySelectorAll('form input[name="id"]').forEach((input) => {
          input.value = String(variant.id);
          input.disabled = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const button = product.querySelector('button[name="add"]');
        if (button) button.disabled = true;
        const price = product.querySelector('.dbc-current-price');
        if (price && prices[String(variant.id)]) price.textContent = prices[String(variant.id)];
        const gallery = product.querySelector('media-gallery');
        if (updateMedia && gallery && variant.featured_media?.id && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(`${product.dataset.section}-${variant.featured_media.id}`, false);
        }
        if (changeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url);
        }
      };
      product.addEventListener('change', (event) => {
        const target = event.target;
        if (!picker.contains(target) || !target.matches('input[type="radio"], select')) return;
        event.stopImmediatePropagation();
        const variant = variants.find((item) => item.option1 === target.value);
        sync(variant, true);
      }, true);
      const initialSync = () => {
        const requested = new URL(window.location.href).searchParams.get('variant');
        const current = radios.find((radio) => radio.checked)?.value || dropdown?.value;
        const variant = variants.find((item) => String(item.id) === requested) || variants.find((item) => item.option1 === current) || variants[0];
        sync(variant, false, Boolean(requested));
      };
      initialSync();
      customElements.whenDefined('media-gallery').then(initialSync);
    });
  }
  initializeDropsDraft(document);
  document.addEventListener('shopify:section:load', (event) => initializeDropsDraft(event.target));
})();
